<template>
  <!-- * John Molt / Blue COver Six  1.0
* Copyright (c) 2025, Blue Cover Six LLC . John Molt. SAll rights reserved.
Code licensed under contract To Reno Police Department / City of Reno, in perpetuity -->
  <v-menu
    dark
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        dark
        color="white"
        v-model="displayDate"
        :label="label"
        prepend-icon="$calendar"
        prepend-icon-color="white"
        readonly
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      :prev-icon="'$arrowLeft'"
      :next-icon="'$arrowRight'"
      dark
      color="grey darken-1"
      v-model="selected"
      @input="updateDate"
      scrollable
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "date_field",
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: "Select Date",
    },
  },
  data() {
    return {
      menu: false,
      selected: this.value, // holds the actual YYYY-MM-DD value
    };
  },
  computed: {
    displayDate() {
      if (!this.selected) return "";
      // format 'YYYY-MM-DD' -> 'MM/DD/YYYY' without using Date()
      const [y, m, d] = this.selected.split("-");
      return `${m}/${d}/${y}`;
    },
  },
  watch: {
    value(newVal) {
      this.selected = newVal;
    },
  },
  methods: {
    updateDate(val) {
      this.$emit("input", val); // sync back to parent via v-model
      this.menu = false; // close after selection
    },
  },
};
</script>
